import { AppConnectionStatuses } from 'integrations-lib/constants/appConnectionStatuses';

import { TReconnectConfig } from '../../types/reconnection-config';
import { DataSyncServiceComponent } from './DataSyncServiceComponent';

export const DataSyncReconnectionConfig: TReconnectConfig = {
  statusesForDisplaying: [AppConnectionStatuses.DISCONNECTED],
  serviceComponent: DataSyncServiceComponent,
};
